import Cookies from 'js-cookie';
import { get } from 'lodash';

import ACTIONS, { GEOFENCING_COOKIES } from 'state/constants';
import { getCurrentDomain } from 'utils/Url';

const setInferredUserCountryCookie = store => next => action => {
  next(action);

  if (
    action.type === ACTIONS.FETCH_GEOFENCING_DATA_SUCCESS &&
    !Cookies.get(GEOFENCING_COOKIES.INFERRED_USER_COUNTRY)
  ) {
    const state = store.getState();
    const inferredUserCountry = get(state, ['geofencing', 'inferredUserCountry']);
    const domain = getCurrentDomain();

    Cookies.set(GEOFENCING_COOKIES.INFERRED_USER_COUNTRY, inferredUserCountry, {
      domain,
    });
  }
};

export default setInferredUserCountryCookie;
